import type { DownloadFromUrl } from '../interfaces';
import { useDownloadFile } from '../singleton';

export const useDownloadFromUrl = ({ fileName, fileUrl }: DownloadFromUrl) => {
  const { downloadContent, loading, progress } = useDownloadFile((s) => ({
    downloadContent: s.downloadContent,
    loading: s.loadingMap[fileName] ?? false,
    progress: s.progressMap[fileName] ?? 0,
  }));

  return {
    downloadFromUrl: () => downloadContent({ fileName, fileUrl }),
    loadingProgress: { loading, progress },
  };
};
